import { Breadcrumbs, Button, Grid, Link, Typography } from "@mui/material";
import { Outlet, Link as RouterLink, useLocation, useParams } from "react-router-dom";
import { BackfillModal } from "../../components";

import { PlusIcon } from "@phosphor-icons/react/dist/csr/Plus";
import { BackfillTable } from "../../components/BackfillTable/BackfillTable";
import { getQueryParams } from "../../lib/Util";
import { useBackfillStore } from "../../store/backfillsStore";

const BackfillsPage = () => {
  const showModal = useBackfillStore((state) => state.showModal);
  const toggleModalOpen = useBackfillStore((state) => state.toggleModalOpen);

  return (
    <Grid container spacing={2}>
      <Grid size={12} container sx={{ justifyContent: "flex-end", flexDirection: "row" }}>
        <Button onClick={() => toggleModalOpen()} data-cy="create-backfill" startIcon={<PlusIcon />}>
          Backfill
        </Button>
      </Grid>
      {showModal && <BackfillModal />}

      <Grid size={12}>
        <BackfillTable />
      </Grid>
    </Grid>
  );
};

const BackfillsCommonPage = () => {
  const { backfillId } = useParams();
  const location = useLocation();
  const { backfillName } = getQueryParams(location.search);
  if (location.pathname.includes("/backfills/list")) {
    return <Outlet />;
  }
  return (
    <>
      <Breadcrumbs>
        <Link component={RouterLink} to="list">
          <Typography variant="body.overline.regular">Backfills</Typography>
        </Link>
        {backfillId && (
          <Typography data-testid="last-breadcrumb">
            <Typography variant="body.overline.bold">{backfillName}</Typography>
          </Typography>
        )}
      </Breadcrumbs>
      <Outlet />
    </>
  );
};

export { BackfillsCommonPage, BackfillsPage };
